import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Search, MoreVertical, X, Share, FileText, Trash2 } from "lucide-react";
import authService from '../../../Services/authService';

function Orders() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const token = authService.getCurrentUsertoken();
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);

  useEffect(() => {
    loadOrders();
  }, []);

  useEffect(() => {
    // Scroll to top on mount
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (!event.target.closest('.dropdown-container')) {
        setOpenDropdownId(null);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const loadOrders = () => {
    const url = new URL(authService.getApiUrl() + 'myorders');
    fetch(url, {
      method: 'POST',
      body: JSON.stringify({ user_id: authService.getCurrentuser().id }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`,
      },
    })
      .then(res => res.json())
      .then(result => {
        const orders = result.data || [];
        setOrders(orders);
        setFilteredOrders(orders);
      })
      .catch(err => console.error(err.message));
  };

  const toggleDropdown = (orderId) => {
    setOpenDropdownId(openDropdownId === orderId ? null : orderId);
  };

  const handleShareHospital = (hospitalName) => {
    alert(`Sharing ${hospitalName}`);
    setOpenDropdownId(null);
  };

  const handleViewOrderDetails = (orderId) => {
    navigate(`/my-orders/${orderId}`);
    setOpenDropdownId(null);
  };

  const handleDeleteOrder = (orderId) => {
    alert(`Deleting order ${orderId}`);
    setOpenDropdownId(null);
  };

const handleSearch = (e) => {
  const query = e.target.value.toLowerCase();
  setSearchQuery(e.target.value); // Keep original case for the input display

  if (!query.trim()) {
    setFilteredOrders(orders);
  } else {
    const filtered = orders.filter(order => {
      const matchesOrderId = order.invoice_number?.toLowerCase().includes(query);
      const matchesTestName = order.orders_items.some(item => item.test_name?.toLowerCase().includes(query));
      //const matchesHospital = order.orders_info?.organization_name?.toLowerCase().includes(query); // optional

      return matchesOrderId || matchesTestName;// || matchesHospital;
    });

    setFilteredOrders(filtered);
  }
};


  return (
    <div className="min-h-screen bg-[#F5F5F7]">
      <div className="max-w-3xl mx-auto px-4 py-6">
        <a href="#" onClick={() => window.history.back()} className="flex items-center text-[#4A4A4A] hover:text-[#951C25] mb-6">
          <ArrowLeft size={18} className="mr-2" />
          <span>Back to Home</span>
        </a>

        <h1 className="text-2xl font-semibold text-[#4A4A4A] mb-6">My Orders</h1>

        <div className="relative mb-6">
          <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
            <Search size={20} className="text-[#4A4A4A]/50" />
          </div>
          <input
            type="text"
            placeholder="Search by test name"
            className="w-full pl-10 pr-4 py-3 border border-[#E0E0E0] rounded-[5px] bg-white focus:outline-none focus:ring-2 focus:ring-[#951C25]/20 focus:border-[#951C25]"
            value={searchQuery}
            onChange={handleSearch}
          />
          {searchQuery && (
            <button
              className="absolute inset-y-0 right-3 flex items-center"
              onClick={() => {
                setSearchQuery("");
                setFilteredOrders(orders);
              }}
            >
              <X size={18} className="text-[#4A4A4A]/50" />
            </button>
          )}
        </div>

        {filteredOrders.length > 0 ? (
          <div className="space-y-4">
            {filteredOrders.map((order) => (
              <div key={order.order_id} className="bg-white rounded-lg border border-[#E0E0E0] overflow-hidden shadow-sm">
                <div className="p-4 flex justify-between items-center">
                  <h2 className="text-sm text-[#4A4A4A]">Order ID: {order.invoice_number}</h2>
                  <div className="relative dropdown-container">
                    <button 
                      className="text-[#4A4A4A]/70 hover:text-[#4A4A4A] p-1" 
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleDropdown(order.order_id);
                      }}
                    >
                      <MoreVertical size={20} />
                    </button>
                    {openDropdownId === order.order_id && (
                      <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-xl z-[9999] border border-[#E0E0E0]">
                        <div className="py-1">
                          <button
                            type="button"
                            className="flex items-center w-full px-4 py-2 text-sm text-[#4A4A4A] hover:bg-[#F5F5F7] text-left"
                            onMouseDown={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              console.log('Navigating to:', `/order-details/${order.invoice_number}`);
                              navigate(`/order-details/${order.invoice_number}`);
                              setOpenDropdownId(null);
                            }}
                          >
                            <FileText size={16} className="mr-2" />
                            Order details
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div
                  className="border-t border-[#E0E0E0] p-4 cursor-pointer hover:bg-[#F5F5F7]/50 transition-colors"
                  onClick={() => navigate(`/order-details/${order.invoice_number}`)}
                >
                  {order.orders_items.map((item, index) => (
                    <div key={index} className="flex items-center mb-2">
                      <div className="w-8 h-8 bg-[#F5F5F7] rounded-md flex items-center justify-center mr-3">
                        <span className="text-sm font-medium text-[#4A4A4A]">{item.quantity}</span>
                      </div>
                      <div className="flex items-center">
                        <X size={14} className="text-[#4A4A4A]/50 mr-2" />
                        <span className="text-base text-[#4A4A4A]">{item.test_name}</span>
                      </div>
                    </div>
                  ))}
                </div>

                <div
                  className="border-t border-[#E0E0E0] px-4 py-3 flex justify-between items-start cursor-pointer hover:bg-[#F5F5F7]/50 transition-colors"
                  onClick={() => navigate(`/order-details/${order.invoice_number}`)}
                >
                  {/* Left Side: Date + Statuses */}
                  <div>
                    <p className="text-sm text-[#4A4A4A]/70 mb-1">
                      Order placed on {new Date(order.orderdate).toLocaleString()}
                    </p>
                    {order.home_order_status && (
                      <p className="text-sm text-[#4A4A4A]/70">
                        Home Order Status:{" "}
                        <span className={`font-medium ${order.order_status_id === 6 ? "text-red-600" : "text-green-600"}`}>
                          {order.home_order_status}
                          </span>
                      </p>
                    )}
                    {order.lab_order_status && (
                      <p className="text-sm text-[#4A4A4A]/70">
                        Diagnostic Center Status:{" "}
                        <span className={`font-medium ${order.lab_order_status_id === 6 ? "text-red-600" : "text-green-600"}`}>
                          {order.lab_order_status}
                        </span>
                      </p>
                    )}


                  </div>

                  {/* Right Side: Price */}
                  <div className="text-right">
                    <p className="text-lg font-semibold text-[#4A4A4A]">
                      ₹{parseFloat(order.final_price).toFixed(2)}
                    </p>
                  </div>
                </div>




              </div>
            ))}
          </div>
        ) : (
          <div className="bg-white rounded-lg border border-[#E0E0E0] p-8 text-center">
            <div className="w-16 h-16 rounded-full bg-[#951C25]/10 flex items-center justify-center mx-auto mb-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#951C25"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
                <polyline points="10 9 9 9 8 9"></polyline>
              </svg>
            </div>
            <h2 className="text-lg font-medium text-[#4A4A4A] mb-2">No Orders Found</h2>
            <p className="text-sm text-[#4A4A4A]/70 mb-4">
              {searchQuery ? "No orders match your search criteria." : "You haven't placed any orders yet."}
            </p>
            <a
              href="/book-tests"
              className="inline-block px-4 py-2 bg-[#951C25] text-white rounded-md text-sm hover:bg-[#951C25]/90"
            >
              Book a Test
            </a>
          </div>
        )}
      </div>
    </div>
  );
}

export default Orders;
